import { Alert, Button, Snackbar } from '@mui/material'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

type Props = {
  open: boolean
  secondsUntilRefresh: number
  onRefreshNow: () => void
}

const AppVersionSnackbar = ({ open, secondsUntilRefresh, onRefreshNow }: Props) => {
  const { t } = useTranslation()

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={(theme) => ({
        position: 'fixed',
        top: 0,
        zIndex: theme.zIndex.drawer + 1,
      })}
    >
      <Alert
        severity="info"
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: 'white',
        }}
      >
        {/* ← Box 1 : le texte du message */}
        <Box sx={{ marginBottom: 1 }}>
          {t('updateAlert.newVersion')}
          {secondsUntilRefresh}
          {t('updateAlert.seconds')}
        </Box>

        {/* ← Box 2 : le bouton poussé à droite */}
        <Box sx={{ marginLeft: 'auto' }}>
          <Button variant="contained" color="primary" onClick={onRefreshNow}>
            {t('updateAlert.now')}
          </Button>
        </Box>
      </Alert>
    </Snackbar>
  )
}
export default AppVersionSnackbar
